import React, { useState, useEffect } from "react";
import { Link, NavLink } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { Form } from "react-bootstrap";
import ExamsDropDown from "../Shared/ExamsDropDown";
import SessionsDropDown from "../Shared/SessionsDropDown";
import WingsDropDown from "../Shared/WingsDropDown";
import ClassesDropDown from "../Shared/ClassesDropDown";
import SectionDropDown from "../Shared/SectionDropDown";
import Examination_navbar from './Examination_navbar';
import { ToastContainer } from 'react-toastify';


const ExamDataSO = () => {

    const [validated, setValidated] = useState(false);
    const [WingId, setWingId] = useState(0);
    const [SessionId, setSessioinId] = useState(() => {
        const stored = parseInt(localStorage.getItem("DefaultSession") || "0", 10);
        return Number.isNaN(stored) ? 0 : stored;
    });
    const [ClassId, setClassId] = useState(0);
    const [SectionID, setSectionID] = useState(0);
    const [FirstExamID, setFirstExamID] = useState(0);
    const [SecondExamID, setSecondExamID] = useState(0);
    const [ThirdExamID, setThirdExamID] = useState(0);
    const [FourthExamID, setFourthExamID] = useState(0);
    const [PrintTotal, setPrintTotal] = useState("No");
    const [Group, setGroup] = useState("No");



    useEffect(() => {
        const urlParams = new URLSearchParams(window.location.search);
        const getInt = (key) => {
            const raw = urlParams.get(key);
            if (raw === null || raw === "") {
                return null;
            }
            const parsed = parseInt(raw, 10);
            return Number.isNaN(parsed) ? null : parsed;
        };

        const firstExam = getInt("FirstExam");
        const secondExam = getInt("SecondExam");
        const thirdExam = getInt("ThirdExam");
        const fourthExam = getInt("FourthExam");
        const sessionId = getInt("SessionID");
        const wingId = getInt("WingId");
        const classId = getInt("Class_ID") ?? getInt("ClassId");
        const sectionId = getInt("Section_Id") ?? getInt("SectionId");

        if (firstExam !== null) setFirstExamID(firstExam);
        if (secondExam !== null) setSecondExamID(secondExam);
        if (thirdExam !== null) setThirdExamID(thirdExam);
        if (fourthExam !== null) setFourthExamID(fourthExam);
        if (sessionId !== null) setSessioinId(sessionId);
        if (wingId !== null) setWingId(wingId);
        if (classId !== null) setClassId(classId);
        if (sectionId !== null) setSectionID(sectionId);
    }, []);

    useEffect(() => {
        const params = new URLSearchParams();
        params.set("FirstExam", String(FirstExamID));
        params.set("SecondExam", String(SecondExamID));
        params.set("ThirdExam", String(ThirdExamID));
        params.set("FourthExam", String(FourthExamID));
        params.set("SessionID", String(SessionId));
        params.set("WingId", String(WingId));
        params.set("Class_ID", String(ClassId));
        params.set("Section_Id", String(SectionID));
        params.set("PrintTotal", PrintTotal);
        params.set("Group", Group);

        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState(null, "", newUrl);
    }, [
        FirstExamID,
        SecondExamID,
        ThirdExamID,
        FourthExamID,
        SessionId,
        WingId,
        ClassId,
        SectionID,
        PrintTotal,
        Group,
    ]);

    const handlesetPrintTotalChange = (e) => {
        if (e.target.checked) {
            setPrintTotal("Yes")
        }
        else {
            setPrintTotal("No");
        }
    }

    const handlesetGroupChange = (e) => {
        if (e.target.checked) {
            setGroup("Yes")
        }
        else {
            setGroup("No");
        }
    }

    const printDataSheetDisabled = FirstExamID === 0;
    const printCollectiveDisabled = FirstExamID === 0 || SecondExamID === 0;
    const printResultCardsDisabled = FirstExamID === 0 || WingId === 0 || ClassId === 0;

    return (
        <>
            <Examination_navbar />
            <ToastContainer />
            <div className="page-head">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-6">
                            <nav aria-label="breadcrumb">
                                <ol className="breadcrumb">
                                    <li className="breadcrumb-item">
                                        <Link to="/Dashboard">Dashboard</Link>
                                    </li>
                                    <li className="breadcrumb-item">
                                        <Link to="/ExaminationSystem/ExaminationDashboard">
                                            Examinations
                                        </Link>
                                    </li>
                                    <li className="breadcrumb-item active" aria-current="page">
                                        Print Marks Sheet
                                    </li>
                                </ol>
                            </nav>
                            <div className="page-title">
                                Print Marks Sheet
                            </div>
                        </div>
                    </div>
                </div>
            </div>


            <div className="page-content">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-md-12">
                            <div className="card">
                                <div className="card-body p-md-4">
                                    <Form
                                        noValidate
                                        validated={validated}
                                    >
                                        <div className="row align-items-center">

                                            <div className="col-md-7">


                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="firstExamSelect" className="col-sm-5 col-form-label">
                                                            Select First Exam:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="firstExamSelect"
                                                                className="form-select"
                                                                name="FirstExam"
                                                                required
                                                                value={FirstExamID}
                                                                onChange={(e) => setFirstExamID(parseInt(e.target.value || "0", 10))}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                            <div className="form-text">
                                                                This is Main Exam will be used for master sheet printing.
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="secondExamSelect" className="col-sm-5 col-form-label">Select Second Exam:</label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="secondExamSelect"
                                                                className="form-select"
                                                                name="SecondExam"
                                                                required
                                                                value={SecondExamID}
                                                                onChange={(e) => setSecondExamID(parseInt(e.target.value || "0", 10))}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                            <div className="form-text">Second term exam for printing on result cards</div>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="thirdExamSelect" className="col-sm-5 col-form-label">
                                                            Select Third Exam:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="thirdExamSelect"
                                                                className="form-select"
                                                                name="ThirdExam"
                                                                required
                                                                value={ThirdExamID}
                                                                onChange={(e) => setThirdExamID(parseInt(e.target.value || "0", 10))}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                            <div className="form-text">Third term exam for printing on result cards</div>
                                                        </div>
                                                    </div>
                                                </div>





                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="fourthExamSelect" className="col-sm-5 col-form-label">
                                                            Select Fourth Exam:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="fourthExamSelect"
                                                                className="form-select"
                                                                name="FourthExam"
                                                                required
                                                                value={FourthExamID}
                                                                onChange={(e) => setFourthExamID(parseInt(e.target.value || "0", 10))}
                                                            >
                                                                <option value="0">Please Select</option>
                                                                <ExamsDropDown />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>


                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="sessionSelect" className="col-sm-5 col-form-label">
                                                            Select Session:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="sessionSelect"
                                                                className="form-select"
                                                                value={SessionId}
                                                                onChange={(e) => setSessioinId(parseInt(e.target.value || "0", 10))}
                                                                name="SessionID"
                                                            >
                                                                <option value="0">---All---</option>
                                                                <SessionsDropDown selectedSession={SessionId} />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>



                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="wingSelect" className="col-sm-5 col-form-label">Select Wing:</label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="wingSelect"
                                                                name="WingId"
                                                                value={WingId}
                                                                onChange={(e) => setWingId(parseInt(e.target.value || "0", 10))}
                                                                className="form-select"
                                                            >
                                                                <option value="0">---All---</option>
                                                                <WingsDropDown />
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>




                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="classSelect" className="col-sm-5 col-form-label">
                                                            Select Class:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="classSelect"
                                                                className="form-select"
                                                                value={ClassId}
                                                                onChange={(e) => setClassId(parseInt(e.target.value || "0", 10))}
                                                                name="Class_ID"
                                                            >
                                                                <option value="0">Please Select</option>
                                                                {SessionId !== 0 && WingId !== 0 && (
                                                                    <ClassesDropDown
                                                                        SessionID={SessionId}
                                                                        WingID={WingId}
                                                                    />
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>




                                                <div className="form-group mb-3">
                                                    <div className="row">
                                                        <label htmlFor="sectionSelect" className="col-sm-5 col-form-label">
                                                            Select Section:
                                                        </label>
                                                        <div className="col-sm-7">
                                                            <select
                                                                id="sectionSelect"
                                                                className="form-select"
                                                                value={SectionID}
                                                                onChange={(e) => setSectionID(parseInt(e.target.value || "0", 10))}
                                                                name="Section_Id"
                                                            >
                                                                <option value="0">Please Select</option>
                                                                {ClassId !== 0 && (
                                                                    <SectionDropDown ClassID={ClassId} />
                                                                )}
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>



                                            </div>

                                            <div className="col-md-4 offset-md-1">
                                                <div className="custom-button">
                                                    <div className="form-check mb-3">

                                                        <input className="form-check-input" type="checkbox" onChange={handlesetPrintTotalChange} checked={PrintTotal === "Yes"} id="PrintTotalCheck" />
                                                        <label htmlFor="PrintTotalCheck" className="form-check-label">
                                                            Print Totals on Master Sheet
                                                        </label>
                                                    </div>


                                                    <div className="form-check mb-3">


                                                        <input className="form-check-input" type="checkbox" onChange={handlesetGroupChange} checked={Group === "Yes"} id="groupTwoExamsCheckbox" />
                                                        <label htmlFor="groupTwoExamsCheckbox" className="form-check-label">
                                                            Group Two Exams
                                                        </label>

                                                    </div>


                                                    <div className="buttons">
                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/ReportPrintExamDataSheet/?ID=${FirstExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}&PrintTotal=${PrintTotal}`}
                                                            className={`button button-primary d-block mb-3 ${printDataSheetDisabled ? 'disabled' : ''}`}>Print Data Sheets</NavLink>


                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/ReportPrintExamDataSheetMultiple/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}&PrintTotal=${PrintTotal}&Group=${Group}`}
                                                            className={`button button-primary  d-block mb-3 ${printCollectiveDisabled ? 'disabled' : ''}`}>Print Collective Data Sheets</NavLink>

                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/PrintResultCards/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&FourthExamID=${FourthExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}`}
                                                            className={`button button-primary w-100 d-block mb-3 ${printResultCardsDisabled ? 'disabled' : ''}`}>Print Result Cards Play Group Nursery Prep</NavLink>

                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/PrintResultCards/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&FourthExamID=${FourthExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}`}
                                                            className={`button button-primary  d-block mb-3 ${printResultCardsDisabled ? 'disabled' : ''}`}>Print Result Cards of Class =1</NavLink>

                                                        <NavLink target="_blank"
                                                            to={`/ExaminationSystem/PrintResultCards/?FirstExamID=${FirstExamID}&SecondExamID=${SecondExamID}&ThirdExamID=${ThirdExamID}&FourthExamID=${FourthExamID}&WingId=${WingId}&ClassId=${ClassId}&SectionId=${SectionID}`}
                                                            className={`button button-primary w-100 d-block mb-3 ${printResultCardsDisabled ? 'disabled' : ''}`}>Print Result Cards New</NavLink>
                                                    </div>
                                                </div>
                                            </div>



                                        </div>
                                    </Form>
                                </div>


                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    )
}

export default ExamDataSO

